import { isNull } from 'utils/tsHelpers';
import { useCallback } from 'react';
import { useClauseConditionsFieldPath } from '../fieldPaths/useClauseConditionsFieldPath';
import { ElementType, useIndex } from '../../../contexts/elementIndex';
import { useFieldArray } from '../../../contexts';
import { createBlankCondition } from '../../../utils/conditionalContent/createBlankCondition';

export const useResetCondition = () => {
  const index = useIndex(ElementType.condition);
  if (isNull(index)) {
    throw new Error('Cannot reset condition: no condition index found in context');
  }
  const fieldPath = useClauseConditionsFieldPath();
  const { update } = useFieldArray({ name: fieldPath });

  return useCallback(() => update(index, createBlankCondition()), [update, index]);
};
